<template>
  <div class="app">    
        <main>
             <router-view></router-view>
        </main>    
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'DefaultContainer',  
}


</script>
<style lang="scss">
nav #bar {
    display: flex;
    justify-content: space-between;
    -webkit-font-smoothing: antialiased;
    font-family: 'lemon_milkregular';
    font-variant: small-caps;
    font-style: italic;
    font-size: 13pt;
    padding-top: 1%;
    padding-left: 5%;
    padding-right: 5%;
    
    a {
         text-decoration: none;
         color: black;
         opacity: .5;
         cursor: pointer;
    }
    a:hover {
        opacity: 1;
    }    
}
</style>
